import { updateEHRAppointment } from '@ax/service';
import { UpdateEHRAppointmentInput } from '@ax/service';
import { useMutation } from '@tanstack/react-query';

export function useUpdateEHRAppointmentApi() {
  return useMutation({
    mutationKey: ['update-ehr-appointment'],
    mutationFn: (data: UpdateEHRAppointmentInput) => updateEHRAppointment(data),
    onError: (error: any) => {
      return error;
    },
  });
}
